import React from "react";
import type { BaseProps } from "@purpur/common-types";
import { Paragraph } from "@purpur/paragraph";
import { VisuallyHidden } from "@purpur/visually-hidden";
import c from "classnames/bind";

import styles from "./pagination-truncation-separator.module.scss";

const cx = c.bind(styles);

export type PaginationTruncationSeparatorProps = Omit<BaseProps<"li">, "children"> & {
  label?: string;
};

const rootClassName = "purpur-pagination-truncation-separator";

export const PaginationTruncationSeparator = ({
  ["data-testid"]: dataTestId = "purpur-pagination-truncation-separator",
  className,
  label,
  ...props
}: PaginationTruncationSeparatorProps) => {
  const classes = cx(className, rootClassName);

  return (
    <li className={classes} data-testid={dataTestId} {...props}>
      <Paragraph>
        <VisuallyHidden>{label}</VisuallyHidden>
        <span aria-hidden="true">...</span>
      </Paragraph>
    </li>
  );
};

PaginationTruncationSeparator.displayName = "PaginationTruncationSeparator";
